import http from 'hub-http/clients/apiClient';
/**
 * Fetches the session info for the given `sessionId`.
 * This is used to check the status of the authentication flow.
 */
export function fetchSessionInfo(portalId, sessionId) {
  return http.get(`/api/unified-auth/v1/authenticators/session/${sessionId}`, {
    query: {
      portalId
    }
  }).then(response => Object.assign({}, response, {
    params: new Map(Object.entries(response.params || {}))
  }));
}